import React, { createContext, useContext } from 'react';

const AppShellContext = createContext(false);
const AppShellSideRailContext = createContext(false);

export function AppShellProvider({ children, sideRail = false }: { children: React.ReactNode; sideRail?: boolean }) {
  return <AppShellContext.Provider value={true}>
    <AppShellSideRailContext.Provider value={sideRail}>{children}</AppShellSideRailContext.Provider>
  </AppShellContext.Provider>;
}

export function useAppShell() {
  return useContext(AppShellContext);
}

export function useSideRail() {
  return useContext(AppShellSideRailContext);
}
